export default "__VITE_ASSET__D7EJVNCT__ 584w";